import * as t from './actionTypes';

/*------------------------------------------------------------------------------------------------*/
/* Create Catalog Collection Actions                                                              */
/*------------------------------------------------------------------------------------------------*/
export const submitCreateCollectionModal = () => ({
  type: t.SUBMIT_CREATE_MODAL,
});

/*------------------------------------------------------------------------------------------------*/
/* Catalog Collection Handlebars Modal Actions                                                    */
/*------------------------------------------------------------------------------------------------*/
export const openHandlebarsModal = (selectedCollectionName /*: string */, collectionData) => ({
  type: t.OPEN_HANDLEBARS_MODAL,
  isHandlebarsModalOpen: true,
  selectedCollectionName,
  collectionData,
});

export const closeHandlebarsModal = () => ({
  type: t.CLOSE_HANDLEBARS_MODAL,
  isHandlebarsModalOpen: false,
  selectedCollectionName: '',
});

export const copyHandlebars = () => ({
  type: t.COPY_HANDLEBARS,
});

export const setUsesSmartRecosHandlebar = (usesSmartRecos /*: boolean */) => ({
  type: t.SET_USES_SMART_RECOS_HANDLEBAR,
  usesSmartRecos,
});

/*------------------------------------------------------------------------------------------------*/
/* Delete Catalog Collection Actions                                                              */
/*------------------------------------------------------------------------------------------------*/
export const deleteCatalogCollection = (collection) => ({
  type: t.DELETE_CATALOG_COLLECTION,
  isFetchingCollections: true,
  collection,
});

export const deleteCatalogCollectionError = (error) => ({
  type: t.DELETE_CATALOG_COLLECTION_ERROR,
  isFetchingCollections: false,
  error,
});

export const deleteCatalogCollectionResponse = (collections /*: [] */, total /*: number */) => ({
  type: t.DELETE_CATALOG_COLLECTION_RESPONSE,
  isFetchingCollections: false,
  collections,
  total,
});

/*------------------------------------------------------------------------------------------------*/
/* Delete Modal Actions                                                                           */
/*------------------------------------------------------------------------------------------------*/
export const openDeleteModal = (selectedCollection) => ({
  type: t.OPEN_DELETE_MODAL,
  isDeleteModalOpen: true,
  selectedCollection,
});

export const closeDeleteModal = () => ({
  type: t.CLOSE_DELETE_MODAL,
  isDeleteModalOpen: false,
});

/*------------------------------------------------------------------------------------------------*/
/* Fetch Catalog Collections Actions                                                              */
/*------------------------------------------------------------------------------------------------*/
export const fetchCatalogCollections = (fetchParams) => ({
  type: t.FETCH_CATALOG_COLLECTIONS,
  isFetchingCollections: true,
  fetchParams,
});

export const fetchCatalogCollectionsError = (error) => ({
  type: t.FETCH_CATALOG_COLLECTIONS_ERROR,
  isFetchingCollections: false,
  error,
});

export const fetchCatalogCollectionsResponse = (collections /*: [] */, total /*: number */) => ({
  type: t.FETCH_CATALOG_COLLECTIONS_RESPONSE,
  isFetchingCollections: false,
  collections,
  total,
});

export const fetchRecentCatalogCollections = () => ({
  type: t.FETCH_RECENT_CATALOG_COLLECTIONS,
  isFetchingCollections: true,
});
